import React, { Fragment } from 'react';
import SecurityAmountDisplay from '../../models/SecurityAmountDisplay';

const FormPartial = (props) => {
  const { securityAmountDisplay } = props;
  let securityAmountDisplayObj = new SecurityAmountDisplay(securityAmountDisplay);

  const validateValue = (field) => {
    securityAmountDisplayObj.validate(field);
    props.setSecurityAmountDisplay(securityAmountDisplayObj.toStateJson());
  }

  const changeValue = (field, value) => {
    securityAmountDisplayObj[field] = value;
    props.setSecurityAmountDisplay(securityAmountDisplayObj.toStateJson());
  }

  return <Fragment>
    <div className="mb-1 col-md-6">
      <label htmlFor="amount" className="form-label mb-1">Security Amount</label>
      <input value={securityAmountDisplay.amount} onChange={(e) => changeValue('amount', e.target.value)} onBlur={(e) => validateValue('amount') } type="number" className="form-control form-control-sm font-size-12" id="amount" aria-describedby="securityAmountHelp" placeholder='Enter Security Amount' />
      <div id="securityAmountHelp" className="form-text text-danger mt-0">
        {securityAmountDisplay.errors.amount}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="display_value" className="form-label mb-1">Security Amount Display</label>
      <input defaultValue={securityAmountDisplay.display_value} onChange={(e) => changeValue('display_value', e.target.value)} onBlur={(e) => validateValue('display_value') } type="text" className="form-control form-control-sm font-size-12" id="display_value" aria-describedby="displayValueHelp" placeholder='Enter Scheme Validity Limit' required />
      <div id="displayValueHelp" className="form-text text-danger mt-0">
        {securityAmountDisplay.errors.display_value}
      </div>
    </div>
  </Fragment>
}

export default FormPartial;
